module.exports = __webpack_public_path__ + "static/media/orangeOpacityMarker.dfb75157.svg";